export enum QrCodeScannerScreenNames {
  MAIN = 'qr-code-scanner-nav',
  SCANNER = 'qr-code-scanner',
  EMPLOYEE = 'qr-code-scanned-employee',
}
